import i18next from "../i18n";

export const tags = {
  sectionTitle: i18next.t("tags.sectionTitle"),
  icon: null,
  list: [
    'Javascript',
    'ReactJS',
    'TypeScript',
    'Ruby',
    'Python',
    'Npm/Yarn',
    'Git',
    'C',
    'C++',
    'Express',
    'SOLID PRINCIPLES',
    'NodeJS',
    'Flask',
    'Django',
    'NextJS',
    'VueJS',
    'Material UI',
    'MongoDB',
    'PostgreSQL',
    'React Router',
    'Sass',
    'Styled Components']
};

export default tags;
